module.exports = __webpack_public_path__ + "static/media/lsd_box.901e9f4a.png";